import type { RevealingIds } from "./RevealingIds";

export const withId = (
  current: RevealingIds,
  id: string,
  revealing: boolean
): RevealingIds => {
  if (current.has(id) === revealing) {
    return current;
  }
  const next = new Set(current);
  if (revealing) {
    next.add(id);
  } else {
    next.delete(id);
  }
  return next;
};
